import { useEffect, useRef } from "react";

const options: AddEventListenerOptions = {
  capture: true,
};

type Callback = (event: Event) => void;

export function useOutsideSyntheticClick(callback: Callback) {
  const ref = useRef<HTMLDivElement>();

  useEffect(() => {
    const handleClick = (event: Event) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }

      callback(event);
    };

    document.addEventListener("click", handleClick, options);
    document.addEventListener("touchend", handleClick, options);

    return () => {
      document.removeEventListener("click", handleClick, options);
      document.removeEventListener("touchend", handleClick, options);
    };
  }, [callback]);

  return ref;
}
